import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Vehicle } from '../../shared/domain';
import { VehiclesDto } from '../../shared/dto/VehiclesDto';
import { VehicleNote } from '../../shared/domain/note';

@Injectable()
export class WatchListActions {
    static LOAD_WATCHLIST = '[WL] Loading WatchList';
    static LOAD_WATCHLIST_SUCCESS = '[WL] Load WatchList Success';
    static ADDTO_WATCHLIST = '[WL] AddTo WatchList';
    static LOAD_WATCHLIST_FAILED = '[WL] load list failed';
    static UPDATE_VEHICLE_NOTE_SUCCESS = '[WL] Update Vehicle Note Success';
    static REMOVE_VEHICLE = '[WL] Remove Vehicle';
    static REMOVE_VEHICLE_SUCCESS = '[WL] Remove Vehicle Success';

    loadWatchList(): Action {
        return {
            type   : WatchListActions.LOAD_WATCHLIST,
            payload: ''
        };
    }

    loadWatchListSuccess(vehicles: VehiclesDto): Action {
        return {
            type   : WatchListActions.LOAD_WATCHLIST_SUCCESS,
            payload: vehicles
        };
    }

    addToWatchList(vehicle: Vehicle): Action {
        return {
            type   : WatchListActions.ADDTO_WATCHLIST,
            payload: vehicle
        };
    }

    loadWatchListFailed(error): Action {
        return {
            type   : WatchListActions.LOAD_WATCHLIST_FAILED,
            payload: error
        };
    }

    updateVehicleNoteSuccess(vehicleNote: VehicleNote): Action {
        return {
            type   : WatchListActions.UPDATE_VEHICLE_NOTE_SUCCESS,
            payload: vehicleNote
        };
    }

    removeVehicle(vehicleId: string): Action {
        return {
            type   : WatchListActions.REMOVE_VEHICLE,
            payload: vehicleId
        };
    }

    removeVehicleSuccess(vehicleId: string): Action {
        return {
            type   : WatchListActions.REMOVE_VEHICLE_SUCCESS,
            payload: vehicleId
        };
    } // todo payload type
}



// WEBPACK FOOTER //
// ./node_modules/@nw/ui-watchlist/store/actions/WatchListActions.ts